import * as _ from 'lodash';
var ChannelModel = /** @class */ (function () {
    function ChannelModel(channels, channel) {
        this.channels = channels;
        this.channel = channel;
    }
    Object.defineProperty(ChannelModel.prototype, "isEnabled", {
        get: function () {
            return this._isEnabled;
        },
        set: function (v) {
            var _this = this;
            this._isEnabled = v;
            var channelData = {
                channelName: this.channelName,
                lineColor: this.lineColor,
                projectionColor: this.projectionColor
            };
            if (v) {
                if (!this.channelName) {
                    return;
                }
                this.channel = channelData;
                var channel = _.find(this.channels, function (h) { return h.channelName === _this.channel.channelName; });
                if (!channel) {
                    this.channels.push(this.channel);
                }
            }
            else {
                for (var i = this.channels.length - 1; i >= 0; i--) {
                    if (this.channels[i].channelName === channelData.channelName) {
                        this.channels.splice(i, 1);
                    }
                }
                this.channel = undefined;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChannelModel.prototype, "lineColor", {
        get: function () {
            return this._lineColor;
        },
        set: function (v) {
            this._lineColor = v;
            if (this.channel) {
                this.channel.lineColor = v;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChannelModel.prototype, "projectionColor", {
        get: function () {
            return this._projectionColor;
        },
        set: function (v) {
            this._projectionColor = v;
            if (this.channel) {
                this.channel.projectionColor = v;
            }
        },
        enumerable: true,
        configurable: true
    });
    return ChannelModel;
}());
export { ChannelModel };
